import type { PriceType } from '@shared/types/frontend/ubff/common';
import type { I18nService } from '@shared/types/i18n';
import type { Optional } from '@shared/types/utils';
import type { TaxAndFeeInclusionPolicy } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/common.pb';

import {
  PRICE_TYPE_PER_NIGHT,
  TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED,
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED,
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED,
} from '@shared/constants/ubff-gateway';

export const isTaxesFeesIncludedPolicy = (
  pricePolicy?: TaxAndFeeInclusionPolicy,
) => pricePolicy === TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED;

export const isTaxesFeesNotIncludedPolicy = (
  pricePolicy?: TaxAndFeeInclusionPolicy,
) => pricePolicy === TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED;

export const isFeesIncludedPolicy = (pricePolicy?: TaxAndFeeInclusionPolicy) =>
  pricePolicy === TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED;

export const getPricePolicyText = ({
  i18n,
  priceType,
  taxAndFeeInclusionPolicy,
}: {
  taxAndFeeInclusionPolicy: Optional<TaxAndFeeInclusionPolicy>;
  i18n: I18nService;
  priceType: PriceType;
}) => {
  if (
    isTaxesFeesIncludedPolicy(taxAndFeeInclusionPolicy) ||
    priceType !== PRICE_TYPE_PER_NIGHT
  ) {
    return i18n.translate('OTARates_TaxesIncluded');
  }

  if (isFeesIncludedPolicy(taxAndFeeInclusionPolicy)) {
    return i18n.translate('OTARates_TaxesExcluded_Only');
  }

  return i18n.translate('dayview_taxes_not_included');
};
